/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Addopportunityowner_Modal_Description3Inputs */

const en_coinvestments_addopportunityowner_modal_description3 = /** @type {(inputs: Coinvestments_Addopportunityowner_Modal_Description3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outreach emails will be sent from the opportunity owner`)
};

/**
* | output |
* | --- |
* | "Outreach emails will be sent from the opportunity owner" |
*
* @param {Coinvestments_Addopportunityowner_Modal_Description3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_addopportunityowner_modal_description3 = /** @type {((inputs?: Coinvestments_Addopportunityowner_Modal_Description3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Addopportunityowner_Modal_Description3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_addopportunityowner_modal_description3(inputs)
});
export { coinvestments_addopportunityowner_modal_description3 as "coInvestments_addOpportunityOwner_modal_description" }